import { IPhone } from '../../types/promoDetails';

export function formatNumber(phone: IPhone): string | null {
  if (!phone.countryCode || !phone.number) {
    return null;
  }

  return `+${phone.countryCode} ${phone.number.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2-$3-$4')}`;
}

export function getPhoneLink(phone?: IPhone): string | null {
  if (!phone || !phone.countryCode || !phone.number) {
    return null;
  }

  return `tel:${phoneToString(phone)}`;
}

export function phoneToString(phone?: IPhone | null) {
  if (phone && phone.countryCode && phone.number) {
    return `+${phone.countryCode}${phone.number.replace(/\D/g, '')}`;
  }

  return '';
}
